import { base64Decode } from '@finect/front-utils/base64';
export const escaped_one_to_xml_special_map = {
  '&amp;': '&',
  '&quot;': '"',
  '&lt;': '<',
  '&gt;': '>'
};
export function decodeXml(string) {
  const string2 = string.replace(/(&amp;)/g, (str, item) => escaped_one_to_xml_special_map[item]);
  return string2.replace(/(&quot;|&lt;|&gt;|&amp;)/g, (str, item) => escaped_one_to_xml_special_map[item]);
}
export const getArticleHtml = str => decodeXml(base64Decode(str));
export const cleanEmptyParagraphs = html => {
  let withoutEmptyParagraphs = html.replace(/(<p><\/p>)+/gi, '');
  withoutEmptyParagraphs = withoutEmptyParagraphs.replace(/(<p> <\/p>)+/gi, '');
  withoutEmptyParagraphs = withoutEmptyParagraphs.replace(/(<p>&nbsp;<\/p>)+/gi, '');
  return withoutEmptyParagraphs;
};
export const sections = [{
  title: 'PLANES',
  subtitle: '',
  link: '/planes-pensiones',
  backgroundImage: 'https://www.finect.com/image/4e67b2051a56b569b6f5eefb1cdf625570a0669a784',
  color: '#fff'
}, {
  title: 'ROBOADVISORS',
  subtitle: 'Inversión automatizada',
  link: 'https://www.finect.com/invertir/roboadvisors',
  backgroundImage: 'https://www.finect.com/image/db23d2bae5b9cc74984386076efb8c141e71fc7ba0f',
  color: '#fff'
}, {
  title: 'ASESORES',
  subtitle: 'Asesores financieros',
  link: 'https://www.finect.com/asesores',
  backgroundImage: 'https://www.finect.com/image/f5752d938ec9b999e14b614df104e99de5a0eff65b7',
  color: '#fff'
}, {
  title: 'PREGUNTAS',
  subtitle: 'Pregunta a la comunidad',
  link: 'https://www.finect.com/preguntas',
  backgroundImage: 'https://www.finect.com/image/8cd752c3b240c1b60bbda17cb2110e839226e648abf',
  color: '#fff'
}, {
  title: 'AGREGADOR',
  subtitle: 'Analiza tus inversiones',
  link: 'https://www.finect.com/tudinero',
  backgroundImage: 'https://www.finect.com/image/81027dbad2548620f9a1ff947d54c02e02ad9c6c2ce',
  color: '#fff'
}];
export const storefrontsHomeSections = [{
  title: 'PLANES',
  subtitle: '',
  link: '/planes-pensiones',
  backgroundImage: 'https://www.finect.com/image/4e67b2051a56b569b6f5eefb1cdf625570a0669a784',
  color: '#fff'
}, {
  title: 'ACCIONES',
  subtitle: '',
  link: 'https://www.finect.com/acciones',
  backgroundImage: 'https://www.finect.com/image/fcf81afe9a01f32bb45bafeb3f09f66bfa0b454092f',
  color: '#fff'
}, {
  title: 'SOCIMIS',
  subtitle: '',
  link: 'https://www.finect.com/acciones/tipo/socimi',
  backgroundImage: 'https://www.finect.com/image/61bcd75c55d41ab6ff09d9000c89105f7724a9bbc72',
  color: '#fff'
}, {
  title: 'ROBOADVISORS',
  subtitle: 'Inversión automatizada',
  link: 'https://www.finect.com/invertir/roboadvisors',
  backgroundImage: 'https://www.finect.com/image/db23d2bae5b9cc74984386076efb8c141e71fc7ba0f',
  color: '#fff'
}, {
  title: 'ASESORES',
  subtitle: 'Asesores financieros',
  link: 'https://www.finect.com/asesores',
  backgroundImage: 'https://www.finect.com/image/f5752d938ec9b999e14b614df104e99de5a0eff65b7',
  color: '#fff'
}, {
  title: 'PREGUNTAS',
  subtitle: 'Pregunta a la comunidad',
  link: 'https://www.finect.com/preguntas',
  backgroundImage: 'https://www.finect.com/image/8cd752c3b240c1b60bbda17cb2110e839226e648abf',
  color: '#fff'
}, {
  title: 'AGREGADOR',
  subtitle: 'Analiza tus inversiones',
  link: 'https://www.finect.com/tudinero',
  backgroundImage: 'https://www.finect.com/image/81027dbad2548620f9a1ff947d54c02e02ad9c6c2ce',
  color: '#fff'
}];